const homepage = {
  path: 'homepage',
  component: resolve => require(['../../../../components/pages/studentUnion/homepage'], resolve)
}

export default homepage
